import { GET_ALL_SCHOLAE_ADMINS, GET_SCHOLAE_ADMIN } from 'actions/admin/schoolAdmins';

const initialState = {
  schoolAdminData: {
    content: [],
  },
  schoolAdmin: {},
};

export default function schoolAdmins(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_SCHOLAE_ADMINS:
      return { ...state, schoolAdminData: action.schoolAdminData };
    case GET_SCHOLAE_ADMIN:
      return { ...state, schoolAdmin: action.admin };
    default:
      return state;
  }
}
